<template>
    <div class="modal" :class="{ 'is-active': isActive }">
        <div class="modal-background"  @click="closeModal"></div>
        <div class="modal-card" style="max-width: 95%; width: 95%; z-index: 100;">
            <header class="modal-card-head">
                <p class="modal-card-title">Statistics</p>
                <button class="delete" aria-label="close"  @click="closeModal"></button>
            </header>
            <section class="modal-card-body">
                <h3 class="text-has-center" v-if="isLoading">Loading...</h3>
                <table class="table is-responsive" v-if="!isLoading">
                    <thead>
                        <tr>
                            <th><span @click="setOrder('AUCTION_DATE')"  class="link">Day</span></th>
                            <th><span @click="setOrder('LOT')"  class="link">Lot</span></th>
                            <th>Photos</th>
                            <th><span @click="setOrder('AUCTION')"  class="link">Auction</span></th>
                            <th><span @click="setOrder('MARKA_NAME')"  class="link">Brand</span></th>
                            <th>Model</th>
                            <th><span @click="setOrder('KUZOV')"  class="link">Chassis</span></th>
                            <th><span @click="setOrder('GRADE')"  class="link">Variant</span></th>
                            <th><span @click="setOrder('MILEAGE')"  class="link">Km's</span></th>
                            <th><span @click="setOrder('YEAR')"  class="link">Year</span></th>
                            <th><span @click="setOrder('COLOR')"  class="link">Color</span></th>
                            <th>Displacement</th>
                            <th><span @click="setOrder('KPP')"  class="link">Transmission</span></th>
                            <th><span @click="setOrder('RATE')"  class="link">Score</span></th>
                            <th><span @click="setOrder('FINISH')"  class="link">Result</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="lot in lots">
                            <td>{{ lot.AUCTION_DATE.split(" ")[0] }}</td>
                            <td>{{ lot.LOT }}</td>
                            <td>
                                <div class="level" @click="openGallery(lot.ID)">
                                    <figure class="image  is-32x32" @click="index = 0" style="float: left;">
                                        <img :src="lot.IMAGES.split('#')[0]">
                                    </figure>
                                    <figure class="image  is-32x32" @click="index = 2">
                                        <img :src="lot.IMAGES.split('#')[1]">
                                    </figure>
                                </div>
                            </td>
                            <td>{{ lot.AUCTION }}</td>
                            <td>{{ lot.MARKA_NAME }}</td>
                            <td>{{ lot.MODEL_NAME }}</td>
                            <td>{{ lot.KUZOV }}</td>
                            <td> <span v-html="lot.GRADE"></span></td>
                            <td>{{ lot.MILEAGE | formatNumber }}</td>
                            <td>{{ lot.YEAR }}</td>
                            <td>{{ lot.COLOR }}</td>
                            <td>{{ lot.ENG_V }}</td>
                            <td>{{ lot.KPP }}</td>
                            <td>{{ lot.RATE }}</td>
                            <td>{{ lot.FINISH | formatNumber}}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="columns" v-if="hasLots && !isLoading">
                    <div class="column has-text-centered">
                        <nav class="pagination is-centered" role="navigation" aria-label="pagination">
                            <ul class="pagination-list">
                                <li><a class="pagination-link" v-if="getCurrentPage > 2" @click="changePage(getFirstPage)">{{ getFirstPage }}</a></li>
                                <li><span class="pagination-ellipsis" v-if="getCurrentPage > 2">&hellip;</span></li>
                                <li><a class="pagination-link" v-if="getCurrentPage > 1" @click="changePage(getCurrentPage - 1)">{{ getCurrentPage - 1 }}</a></li>
                                <li><a class="pagination-link is-current" @click="changePage(getCurrentPage)">{{ getCurrentPage }}</a></li>
                                <li><a class="pagination-link" v-if="getCurrentPage < getLastPage"  @click="changePage(getCurrentPage + 1)">{{ getCurrentPage + 1 }}</a></li>
                                <li><span class="pagination-ellipsis" v-if="getCurrentPage + 1 < getLastPage">&hellip;</span></li>
                                <li><a class="pagination-link" @click="changePage(getLastPage)" v-if="getCurrentPage + 1 < getLastPage">{{ getLastPage }}</a></li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button" @click="closeModal">Close</button>
            </footer>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            isLoading() {
                return this.$store.getters.getMarketPriceModalLoadingStatus
            },
            lots() {
                return this.$store.getters.getMarketPriceModalLots
            },
            lotId() {
                return this.$store.getters.getActiveMarketPriceModalLotId
            },
            isActive: function () {
                return this.$store.getters.getActiveMarketPriceModalStatus
            },
            hasLots() {
                return this.$store.getters.getMarketPriceModalLots.length > 0
            },
            getFirstPage() {
                return 1
            },
            getCurrentPage() {
                return this.$store.getters.getActiveMarketPriceModalCurrentPage
            },
            getLastPage() {
                return this.$store.getters.getActiveMarketPriceModalLastPage
            }
        },
        methods: {
            openGallery(lotId) {
                this.$store.dispatch('setResultGalleryOptions', { index: 0 })
                this.$store.dispatch('fetchAllLotPhotosByLotId', lotId)
            },
            closeModal() {
                this.$store.dispatch('changeMarketPriceModalStatus', { status: false, lotId: '' })
                this.$store.dispatch('resetMarketPriceModalQuery')
            },
            changePage(page) {
                let offset = 30 * page
                this.$store.dispatch('changeMarketPriceModalQueryFieldValue', { field: 'limit_start', value: offset})
                this.$store.dispatch('fetchMarketPriceModalLots', this.lotId)
            },
            setOrder(column){
                this.$store.dispatch('changeMarketPriceModalQueryFieldValue', { field: 'order_column', value: column})
                this.$store.dispatch('changeMarketPriceModalQueryOrderType')
                this.$store.dispatch('fetchMarketPriceModalLots', this.lotId)
            }
        }
    }
</script>

<style scoped>
    th {
        font-size: small;
    }
    td {
        font-size: small;
    }
    .link {
        border-bottom: 1px solid blue;
        cursor: pointer;
    }
    .image {
        cursor: pointer;
    }
    @media screen and (max-width: 800px) {
        .is-responsive {
            width: 100%;
            border-collapse: collapse;
            border-spacing: 0;
            display: block;
            position: relative;
        }
        .is-responsive td:empty:before {
            content: " ";
        }
        .is-responsive th,
        .is-responsive td {
            margin: 0;
            vertical-align: top;
        }
        .is-responsive th {
            text-align: left;
        }
        .is-responsive thead {
            border-right: solid 2px #dbdbdb;
            display: block;
            float: left;
        }
        .is-responsive thead tr {
            display: block;
            padding: 0 10px 0 0;
        }
        .is-responsive thead tr th::before {
            content: " ";
        }
        .is-responsive thead td,
        .is-responsive thead th {
            border-width: 0 0 1px;
        }
        .is-responsive tbody {
            display: block;
            width: auto;
            position: relative;
            overflow-x: auto;
            white-space: nowrap;
        }
        .is-responsive tbody tr {
            display: inline-block;
            vertical-align: top;
        }
        .is-responsive th {
            display: block;
            text-align: right;
        }
        .is-responsive td {
            display: block;
            min-height: 1.25em;
            text-align: left;
            font-size: 12px !important;
        }
        .is-responsive th:last-child,
        .is-responsive td:last-child {
            border-bottom-width: 0;
        }
        .is-responsive tr:last-child td:not(:last-child) {
            border: 1px solid #dbdbdb;
            border-width: 0 0 1px;
        }
        .is-responsive.is-bordered td,
        .is-responsive.is-bordered th {
            border-width: 1px;
        }
        .is-responsive.is-bordered tr td:last-child,
        .is-responsive.is-bordered tr th:last-child {
            border-bottom-width: 1px;
        }
        .is-responsive.is-bordered tr:last-child td,
        .is-responsive.is-bordered tr:last-child th {
            border-width: 1px;
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/Auctions/Lot/Details/MarketPrice.vue